import {Injectable} from "@angular/core";
import {environment as global_env} from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class Perzonalized_Console{
  log(message: string, level: 'debug' | 'info' | 'warn' | 'error' = 'debug'): void {
    const prefix = '[SpeechRecognition]';
    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent); //Detecta si es un dispositivo mobile.
    if (level === 'error'&& !global_env.production) console.error(`${prefix} ${message}`);
    if (level === 'warn'&& !global_env.production) console.warn(`${prefix} ${message}`);
    if (level === 'info' && !global_env.production) console.info(`${prefix} ${message}`);
    if (level === 'debug' && !global_env.production) console.debug(`${prefix} ${message}`);
  }
}
